import { tokens } from '@fluentui/react-components'

const style = {
  error: {
    color: tokens.colorPaletteRedBackground3,
    width: '100%',
    maxWidth: '70%'
  }
}

export default style
